import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'control',
    component: () => import('@/views/ControlScreen.vue'),
    meta: {
      title: 'Control Panel - Multi-Screen Display',
      mode: 'control',
    },
  },
  {
    path: '/display/:displayId?',
    name: 'display',
    component: () => import('@/views/DisplayScreen.vue'),
    meta: {
      title: 'Display - Multi-Screen Display',
      mode: 'display',
    },
    props: true,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '404 - Not Found',
    },
  },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
})

// Update document title on navigation
router.beforeEach((to, _from, next) => {
  document.title = (to.meta.title as string) || 'Multi-Screen Display'
  next()
})

export default router
